import LevelsDataForm from 'components/crudTreasuryAccountsValidationRulesData/AdditionalTabs/LevelsDataForm'
import LevelValuesCrudTable from 'components/crudTreasuryAccountsValidationRulesData/AdditionalTabs/LevelValuesCrudTable'
import LevelValuesDataForm from 'components/crudTreasuryAccountsValidationRulesData/AdditionalTabs/LevelValuesDataForm'
import UsesDataForm from 'components/crudTreasuryAccountsValidationRulesData/AdditionalTabs/UsesDataForm'
import CrudTreasuryAcountsValidationRules from 'components/crudTreasuryAccountsValidationRulesData/treasuryAccountsValidationRulesData'
import ListCrudTabContent from 'components/genericCrud/ListCrudTabContent'
import ValuesCrudTable from 'components/genericCrud/ValuesCrudTable'
import { CRUD_TREASURY_ACCOUNTS_VALIDATION_RULES_DATA } from 'utils/RoutePath'
export const treasuryAccountsValidationRulesCrudConfig = {
	id: 'treasuryAccountsValidationRulesCrud', // igual a la constante del path
	key: 'cod_val', // nombre de la llave, generalmente ni (número interno) + definición
	descrip: 'descrip', // nombre de la llave uttyilizada para mostrar el nombre del item a modificar
	searchMethod: 'get', // método utilizado en la búsqueda, puede ser GET o POST
	category: 'C', // categoría de ABM, A para normales, C para config
	translation: 'treasury_accounts_validation_rules', // nombre de la llave en el artreasuryAccountsValidationRulesCrudhivo de traducciones
	dataUrl: CRUD_TREASURY_ACCOUNTS_VALIDATION_RULES_DATA, // constante de la URL definida en el punto 1.
	urlApi: 'abm_tes_valcta', // nombre del root de la API
	component: ListCrudTabContent, // Componente a utilizar en React
	tabsList: [
		// Lista de TABS si tiene, y si son genéricas ( Básicos, Atributos, Comisiones)
		{
			key: 'basic', // Llave de la tab, puede ser basic, atrib, comission.
			title: 'CRUDS.general_use.basic_tab', // Llave del título en el archivo de traducciones
			tabComponent: CrudTreasuryAcountsValidationRules
		},
		{
			key: 'levels_tab',
			title: 'CRUDS.general_use.levels_tab',
			urlApi: 'abm_tes_valcta_niveles',
			tabId: 'cod_val',
			valueId: 'nivel',
			component: LevelsDataForm,
			tabComponent: ValuesCrudTable
		},
		{
			key: 'values_tab',
			title: 'CRUDS.general_use.values_tab',
			urlApi: 'abm_tes_valcta_valores',
			tabId: 'cod_val',
			valueId: 'id',
			component: LevelValuesDataForm,
			tabComponent: LevelValuesCrudTable
		},
		{
			key: 'uses_tab',
			title: 'CRUDS.general_use.uses_tab',
			urlApi: 'abm_tes_valcta_uso',
			tabId: 'cod_val',
			valueId: 'catributo',
			component: UsesDataForm,
			tabComponent: ValuesCrudTable
		}
	],
	tabsGroups: ['grilla', 'grupo.niveles', 'grupo.valores', 'grupo.uso'],
	tabsGroupsAlta: ['principal', 'grupo.niveles', 'grupo.valores', 'grupo.uso']
}
